import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Checkbox, Divider, Modal, Typography } from 'antd'
import React, { useEffect, useState } from 'react'
import { CancelTaskBooking, CheckCancelBookingDto, RefundPolicy } from '../../../../definition'
import { asyncCheckBookingCancel, asyncGetRefundPolicy } from '../../../../services/booking.service'
import moment from 'moment'
import { ConfirmCancalBooking } from './confirm-cancel-booking'

interface CancelBookingProps {
  trigger: React.ReactNode
  bookingId: string
  singleCol?: boolean
  onSuccess: () => void
}

export const caculateRefund = (selectedtasks: CancelTaskBooking[]) => {
  let finalRefund = 0
  let refundSubTotal = 0

  selectedtasks.forEach((task) => {
    refundSubTotal += task.refundAmount
    finalRefund += task.refundAmount
  })

  return {
    refundSubTotal,
    finalRefund
  }
}

const CancelBooking = ({ trigger, bookingId, singleCol, onSuccess }: CancelBookingProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [cancelBookingDetail, setCancelBookingDetail] = useState<CheckCancelBookingDto | null>(null)
  const [selectedTask, setSelectedTask] = useState<CancelTaskBooking[]>([])
  const [refundPolicy, setRefundPolicy] = useState<RefundPolicy | null>(null)

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    asyncGetCheckCancelDetail()
    getetRefuncPolicy()
  }, [onSuccess])

  const asyncGetCheckCancelDetail = async () => {
    const data = await asyncCheckBookingCancel(bookingId)
    setCancelBookingDetail(data)
  }
  const getetRefuncPolicy = async () => {
    const data = await asyncGetRefundPolicy()
    setRefundPolicy(data)
  }

  const getTaskStyle = (task: CancelTaskBooking) => {
    let bgContainer = '#fff'
    if (!task.refundAble) {
      bgContainer = '#E9E9E9'
    }
    if (selectedTask.find((t) => t.taskId === task.taskId)) {
      bgContainer = '#E7F3F1'
    }
    return { bgContainer }
  }
  return (
    <div>
      <div onClick={() => setIsModalOpen(true)}>{trigger}</div>
      <Modal width={singleCol ? 700 : 1200} closable={false} open={isModalOpen} onCancel={handleCancel} footer={null}>
        <Typography.Title level={4} className='modal-title'>
          Cancel Booking - Part 1
        </Typography.Title>
        <div className='content'>
          <div className={`cancel-booking-content `}>
            <div className={`cancel-booking-col ${singleCol ? 'span-full' : ''}`}>
              <div className='cancel-policy'>
                <label>Cancellation Fee Policy:</label>
                {refundPolicy?.cancellationFeePolicy.map((policy) => {
                  return <ul>&#9679; {policy}</ul>
                })}
              </div>
              <div className='cancel-reason'>
                <label>Choose one/multiple sessions to cancel:</label>
                <div className='cancel-reason-container'>
                  {cancelBookingDetail?.tasks.map((task, index) => {
                    const renderRefund = (t: CancelTaskBooking) => {
                      if (!t.refundAble) {
                        return <div>No refund</div>
                      } else {
                        if (!task.refundFee) {
                          return <div>Full refund</div>
                        } else {
                          return <div style={{ color: '#B01212' }}>Fee: ${task.refundFee}</div>
                        }
                      }
                    }
                    return (
                      <div
                        className='cancel-reason-item'
                        style={{
                          background: getTaskStyle(task).bgContainer
                        }}
                      >
                        <div className='cancel-reason-index'>
                          Session {cancelBookingDetail.tasks.length > 1 ? `${index + 1}` : ''}
                        </div>
                        <div style={{ fontSize: 10 }}>
                          <div>{moment(task.timeSlotBeginAt).format('DD/MM/YYYY HH:mm')}</div>
                          <div>{task.refundNote}</div>
                        </div>
                        <div style={{ fontSize: 10 }}>
                          {task.refundAmount !== cancelBookingDetail.perSession && (
                            <div style={{ textDecoration: 'line-through' }}>
                              ${cancelBookingDetail.perSession.toFixed(2)}
                            </div>
                          )}
                          <div
                            style={{
                              fontWeight: 700,
                              fontSize: 14
                            }}
                          >
                            <div>${parseFloat(task.refundAmount.toFixed(3))}</div>
                          </div>

                          {renderRefund(task)}
                        </div>
                        <div>
                          <Checkbox
                            disabled={!task.refundAble}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedTask([...selectedTask, { ...task, index }])
                              } else {
                                setSelectedTask([...selectedTask].filter((t) => t.taskId !== task.taskId))
                              }
                            }}
                          />
                        </div>
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
            <div className={`cancel-booking-col ${singleCol ? 'span-full' : ''}`}>
              <div className='cancel-details'>
                <label>Contract Booking Details</label>
                <div className='cancel-details-item'>
                  <label>Service: </label>
                  <div>{cancelBookingDetail?.serviceName}</div>
                </div>
                <div className='cancel-details-item'>
                  <label>Service Value:</label>
                  <div>${cancelBookingDetail?.serviceValue.toFixed(2)}</div>
                </div>
                <div className='cancel-details-item'>
                  <label>Total Sessions: </label>
                  <div>{cancelBookingDetail?.tasks.length}</div>
                </div>
                <div className='cancel-details-item'>
                  <label>Per Session: </label>
                  <div>${cancelBookingDetail?.perSession.toFixed(2)}</div>
                </div>
              </div>
              <div className='cancel-warning'>
                <ExclamationCircleOutlined style={{ color: 'red', marginTop: 6 }} />
                <div>
                  <label>
                    Customer will receive refund based on timing and completion status. Cancellation fees apply.{' '}
                  </label>
                  <div>Please review the breakdown below carefully.</div>
                </div>
              </div>
              {!singleCol && (
                <div className='cancel-caculation'>
                  <label>Refund Calculation</label>
                  {selectedTask.map((task, taskIndex) => {
                    return (
                      <div className='cancel-caculation-item'>
                        <div>
                          Session {task.index + 1} : {task.refundFee ? '(50% penalty)' : '(Free cancellation)'}
                        </div>
                        <div>${task.refundAmount.toFixed(2)}</div>
                      </div>
                    )
                  })}

                  <Divider style={{ marginTop: 0, marginBottom: 0 }} />
                  <div className='cancel-caculation-item'>
                    <label>Subtotal Refund:</label>
                    <label>${caculateRefund(selectedTask || []).refundSubTotal.toFixed(2)}</label>
                  </div>
                  <Divider style={{ marginTop: 0, marginBottom: 0 }} />
                  <div className='cancel-caculation-item'>
                    <label>Final Refund Amount:</label>
                    <label>${caculateRefund(selectedTask || []).finalRefund.toFixed(2)}</label>
                  </div>
                </div>
              )}
            </div>
            <div className='cancel-booking-col action-button'>
              <Button className='secondary' style={{ width: '100%' }} onClick={handleCancel}>
                Back
              </Button>
            </div>
            <div className='cancel-booking-col action-button'>
              {selectedTask.length > 0 ? (
                <ConfirmCancalBooking
                  refundPolicy={refundPolicy!}
                  tasks={selectedTask}
                  trigger={
                    <Button className='danger' style={{ width: '100%', fontWeight: 600 }}>
                      Proceed with Cancellation
                    </Button>
                  }
                  bookingId={bookingId}
                  onSave={() => {
                    setSelectedTask([])
                    onSuccess()
                    setIsModalOpen(false)
                  }}
                  cancelBookingDetail={cancelBookingDetail!}
                />
              ) : (
                <Button className='danger' disabled style={{ width: '100%', fontWeight: 600 }}>
                  Proceed with Cancellation
                </Button>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default CancelBooking
